import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common-services/common.service';
import { downloadFiles, formatBytes } from 'src/app/shared/utils';
import {
  NDAStatusLabel,
  KYCStatus,
  UserType,
} from 'src/app/shared/constants/constants';
import { environment } from 'src/environments/environment';
import { CancelledChequeDialogComponent } from '../cancelled-cheque-dialog/cancelled-cheque-dialog.component';
import { ProfileService } from '../profile.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { InterestUpdateDialogComponent } from '../interest-update-dialog/interest-update-dialog.component';
import { IndustryUpdateDialogComponent } from '../industry-update-dialog/industry-update-dialog.component';
import { cloneDeep, first, last } from 'lodash';
import { ZipcodeConfirmationDialogComponent } from '../../registration-module/zipcode-confirmation-dialog/zipcode-confirmation-dialog.component';
import { Subject, debounceTime, distinctUntilChanged, switchMap, of } from 'rxjs';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import {
  SearchCountryField,
  CountryISO,
  PhoneNumberFormat,
} from 'ngx-intl-tel-input';

enum kycFilesKey {
  KD_AUTHRISE_ID = 'KD_AUTHRISE_ID',
  //KD_OWNER_ID = 'KD_OWNER_ID',
  KD_TAX_CERTIFICATION = 'KD_TAX_CERTIFICATION',
  KD_PERMITS = 'KD_PERMITS',
  RA_REGISTRATION_CERTIFICATES = 'RA_REGISTRATION_CERTIFICATES',
  RA_UTILITY_BILLS = 'RA_UTILITY_BILLS',
  RA_OWNERSHIP_DOC = 'RA_OWNERSHIP_DOC',
  CA_REGISTRATION_CERTIFICATES = 'CA_REGISTRATION_CERTIFICATES',
  CA_UTILITY_BILLS = 'CA_UTILITY_BILLS',
  CA_OWNERSHIP_DOC = 'CA_OWNERSHIP_DOC',
  FB_BANK_STATEMENT = 'FB_BANK_STATEMENT',
  FB_FINANCIAL_STATEMENT = 'FB_FINANCIAL_STATEMENT',
  FB_TAX_RETURN = 'FB_TAX_RETURN',
  FB_GENERAL_LIABILITY = 'FB_GENERAL_LIABILITY',
  FB_PRODUCT_LIABILITY = 'FB_PRODUCT_LIABILITY',
  CANCEL_CHEQUE = 'CANCEL_CHEQUE',
}
@Component({
  selector: 'app-profileupdate',
  templateUrl: './profileupdate.component.html',
  styleUrls: ['./profileupdate.component.scss'],
})
export class ProfileupdateComponent implements OnInit {
  // show tabs
  financeTab: boolean = false;
  companyTab: boolean = false;
  kycTabShow: boolean = false;
  tncTab: boolean = false;

  public loading = false;
  primaryColour = '#DA2128';
  secondaryColour = '#DA2128';
  baseUrl = environment.BASE_URL;
  @ViewChild('regionSelect') regionSelect: any;
  uploadedDocumentInfo!: any;
  documentInfo: any = {
    userType: 'Customer',
    documentUseFor: 'brochure',
    baseUrl: this.baseUrl,
  };
  fileUploadConfig = {
    buttonName: 'Upload Brochure/Presentation',
    fileSizeLimit: 10485760, // 10 mb in bytes
    fileFormats: '.xls, .xlsx, .pdf, .doc, .docx, .zip, .ppt', // supported file formats for file picker
  };
  resetFileUpload = false;
  interestData: any[] = [];
  interestsList: any = [];
  uniqueInterestIds = new Set<number>();
  userId: string = '';
  industryData: any[] = [];
  countryData: any[] = [];
  stateData: any[] = [];
  cityData: any[] = [];
  categoryData: any[] = [];
  timelineList: any = [];
  yearOptions: number[] = [];
  stepDisabled: boolean = false;
  files: any[] = [];
  regionsList: any[] = [];
  manPowerList: any[] = [];
  countriesList: any[] = [];
  revenueList: any[] = [];
  categoriesList: any[] = [];
  regionSelectionForm!: FormGroup;
  disabledSelect = true;
  regionWiseCountriesList: Map<string, any> = new Map();
  regionsForm!: FormGroup;
  deletedRegions: number[] = [];
  deletedCountries: number[] = [];
  isChecked = true;
  isNewDev = true;
  interestValidationText = '';
  selectedIndustryList: any = [];
  selectedInterestsList: any = [];
  fileUploadDoc: any = {};
  developmentPayload: any;
  industryList: any = [];
  companySizeData: any[] = [];
  companyProfileForm!: FormGroup;
  financeProfileForm!: FormGroup;
  profileInfo: any;
  profileInfo1: any;
  updateFlag: number = 1;
  companyupdatedData: any;
  financeUpdatedData: any;
  interestValidation: boolean = false;

  fullAddress: any;
  sampleData: any;
  private zipDebouncer$: Subject<string> = new Subject();
  searchZipcode = '';
  isDialogOpen: boolean = false;
  turnOvers: any = [];
  obj: any;
  obj1: any;
  showStateCitySelect: boolean = false;
  selectedStateId: any;
  legalStatus: any;
  categoryOfBusiness: any;
  lastThreeYears: any[] = [];
  kycAttachment!: {
    id?: any;
    fileId: any;
    fileName: string;
    type: string;
    size: string;
    userType: UserType;
    documentUseFor: string;
    location: string;
    fileUploadStatus: boolean;
    presignedUrl: string;
  };
  kycData: any;
  kycTab!: boolean;
  KYCForm!: FormGroup;
  cancelledCheque: any;
  cancelledChequeslocalArr: any;
  cinData: any;
  taxNumberData: any;
  countryName: any;
  headquarterCountryName: any;
  showCancelledCheque: boolean = true;
  @ViewChild('cancelledChequeFileSelector')
  cancelledChequeFileSelector!: ElementRef;
  showBusinessOthers: boolean = false;
  formatBytes = formatBytes;
  showHeadquarterForm = false;
  headQuaterForm: FormGroup = new FormGroup({});
  showHStateCitySelect: boolean = false;
  headquarterstateData: any[] = [];
  headquarterCityData: any[] = [];
  searchZipcodeHeadquarter = '';
  private zipDebouncerHeadquarter$: Subject<string> = new Subject();
  fullAddressHeadQuarter: any;
  sampleDataHeadQuarter: any;
  isHeaquarterAdrressSame = true;

  KYCStatus: any = KYCStatus;
  isSameAsAddress: boolean = false;
  activeIndex: number = 1;
  custId = sessionStorage.getItem('customercompanyId') || '';
  kycFilesMap: Map<string, any> = new Map();
  documentInfoKyc: any = {
    userType: UserType.Customer,
    documentUseFor: 'KYC',
    baseUrl: this.baseUrl,
  };
  fileUploadConfigKyc = {
    uploadLabel: 'Input File',
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File or',
    isMultiple: false,
    fileSizeLimit: 10485760 * 10, // 100 mb in bytes
    fileLocation: `customer/${this.custId}/kycFiles`,
    fileFormats:
      '.xls, .xlsx, .pdf, .doc, .docx, .zip, .ppt, .png, .jpeg, .jpg', // supported file formats for file picker
  };
  kycFilesKey: any = kycFilesKey;
  mandatoryKycKey = [
    'KD_AUTHRISE_ID',
    'KD_TAX_CERTIFICATION',
    'RA_REGISTRATION_CERTIFICATES',
    'CA_REGISTRATION_CERTIFICATES',
    'FB_BANK_STATEMENT',
    'CANCEL_CHEQUE',
  ];

  flag = false;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];

  cinCountryData: any[] = [];
  isCinReadonly = true;

  msmeCertificate = false
  resetFileUploader = true;
  uploadCertificateConfig = {
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File or',
    isMultiple: false,
    fileSizeLimit: 10485760, // 10 mb in bytes
    fileLocation: `customer/${this.custId}/msmeCertificate`,
    fileFormats: '.xls, .xlsx, .pdf, .doc, .docx, .zip, .ppt, .png, .jpeg, .jpg',
  };
  documentQuoteInfo: any = {
    userType: UserType.Admin,
    documentUseFor: 'MSME Certificate',
    baseUrl: this.baseUrl,
  };
  uploadedCertificateInfo: any = []
  currencyData: any
  partyType1Data: any
  partyType2Data: any
  partyType3Data: any
  partyType4Data: any

  searchInputState$ = new Subject<string>();
  searchInputCountry$ = new Subject<string>();
  searchInputCity$ = new Subject<string>();

  searchInputStateHeadQuarter$ = new Subject<string>();
  searchInputCountryHeadQuarter$ = new Subject<string>();
  searchInputCityHeadQuarter$ = new Subject<string>();
  headQuarterCountryData: any[] = [];
  showOtherEntityType: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private http: HttpClient,
    private profileService: ProfileService
  ) {
    this.regionSelectionForm = new FormGroup({
      selectedRegion: new FormControl('', Validators.required),
    });

    this.regionsForm = this.formBuilder.group({
      regions: this.formBuilder.array([]),
    });
  }

  ngOnInit(): void {
    this.userId = sessionStorage.getItem('customeruserId') || '';
    this.getCountry();
    this.getLastThreeYears();
    this.createCompanyProfileForm();
    this.createFinanceProfileForm();
    this.initializeYearOptions();
    this.getCinCountry();
    this.getkycData();
    this.createKYCForm();
    this.updateBusinessOthersValidation();
    this.getCategoryOfBusiness();
    this.getLegalStatus();
    this.getCinManagement();
    this.getTaxNumberManagement();
    this.getMasterData();
    this.financeProfile();
    this.getRegionsListData();
    this.getTimelineData();
    this.getTurnOver();
    this.getCompanySize();
    this.customerProfileData();
    this.setupSearchDebouncerHeadquarter();
    this.setupSearchCountryDebouncer()
    this.setupSearchStateDebouncer();
    this.setupSearchCityDebouncer()
    this.setupSearchCountryHeadQuarterDebouncer()
    this.setupSearchStateHeadQuarterDebouncer();
    this.setupSearchCityHeadQuarterDebouncer()

    this.companyProfileForm.get('country')?.valueChanges.subscribe(country => {
      const validCountry = this.countryData?.find((c) => c.countryName == country) || this.countryData?.find((c) => c.id == country);
      if (validCountry == undefined) {
        const countryControl = this.companyProfileForm.get('country');

        if (countryControl) {
          countryControl.setErrors({ invalidCountry: true });
          this.companyProfileForm.get('state')?.disable();
          this.companyProfileForm.get('city')?.disable();
        }
      }
      else {
        const countryControl = this.companyProfileForm.get('country');

        if (countryControl) {
          if (countryControl.errors != null) {
            countryControl.setErrors(null);
            countryControl.updateValueAndValidity();
          }

          this.companyProfileForm.get('state')?.disable();
          this.companyProfileForm.get('city')?.disable();
        }
        if (country) {
          this.companyProfileForm.get('state')?.enable();
        } else {
          this.companyProfileForm.get('state')?.disable();
          this.companyProfileForm.get('city')?.disable();
        }
      }
    });
    this.companyProfileForm.get('state')?.valueChanges.subscribe(state => {
      const valid = this.stateData?.find((c) => c.stateName == state) || this.stateData?.find((c) => c.id == state);
      if (this.stateData.length != 0 && state) {
        if (valid == undefined) {
          const stateControl = this.companyProfileForm.get('state');
          if (stateControl) {
            stateControl.setErrors({ invalidState: true });
          }
        }

      }
      if (state) {
        this.companyProfileForm.get('city')?.enable();
      } else {
        this.companyProfileForm.get('city')?.disable();
      }
    });
    this.companyProfileForm.get('city')?.valueChanges.subscribe(city => {
      if (this.cityData.length != 0 && city) {
        const valid = this.cityData?.find((c) => c.cityName == city) || this.cityData?.find((c) => c.id == city);
        if (valid == undefined) {
          const cityControl = this.companyProfileForm.get('city');

          if (cityControl) {
            cityControl.setErrors({ invalidCity: true });
          }
        }

      }
      else {
        const cityControl = this.companyProfileForm.get('city');

        if (cityControl) {
          if (cityControl.errors != null) {
            cityControl.setErrors(null);
          }
        }
      }
    });

    this.headQuaterForm.get('headquarterCountryId')?.valueChanges.subscribe(country => {
      const validCountry = this.headQuarterCountryData?.find((c) => c.countryName == country) || this.headQuarterCountryData?.find((c) => c.id == country);
      if (validCountry == undefined) {
        const countryControl = this.headQuaterForm.get('headquarterCountryId');

        if (countryControl) {
          countryControl.setErrors({ invalidCountry: true });
          this.headQuaterForm.get('headquarterState')?.disable();
          this.headQuaterForm.get('headquarterCity')?.disable();
        }
      }
      else {
        const countryControl = this.headQuaterForm.get('headquarterCountryId');
        if (countryControl) {
          if (countryControl.errors != null) {
            countryControl.setErrors(null);
            countryControl.updateValueAndValidity();
          }

          this.headQuaterForm.get('headquarterState')?.disable();
          this.headQuaterForm.get('headquarterCity')?.disable();
        }
        if (country) {
          this.headQuaterForm.get('headquarterState')?.enable();
        } else {
          this.headQuaterForm.get('headquarterState')?.disable();
          this.headQuaterForm.get('headquarterCity')?.disable();
        }
      }
    });
    this.headQuaterForm.get('headquarterState')?.valueChanges.subscribe(state => {
      if (this.headquarterstateData.length != 0 && state) {
        const valid = this.headquarterstateData?.find((c) => c.stateName == state) || this.headquarterstateData?.find((c) => c.id == state);
        if (valid == undefined) {
          const stateControl = this.headQuaterForm.get('headquarterState');

          if (stateControl) {
            stateControl.setErrors({ invalidState: true });
            this.headQuaterForm.get('headquarterCity')?.disable();
          }
        }

      }
      if (state) {
        this.headQuaterForm.get('headquarterCity')?.enable();
        this.headQuaterForm.get('headquarterCity')?.setErrors(null);
      } else {
        this.headQuaterForm.get('headquarterCity')?.disable();
      }
    });
    this.headQuaterForm.get('headquarterCity')?.valueChanges.subscribe(city => {
      if (this.cityData.length != 0 && city) {
        const valid = this.headquarterCityData?.find((c) => c.cityName == city) || this.cityData?.find((c) => c.id == city);
        if (valid == undefined) {
          const cityControl = this.headQuaterForm.get('headquarterCity');

          if (cityControl) {
            cityControl.setErrors({ invalidCity: true });
          }
        }

      }
      else {
        const cityControl = this.headQuaterForm.get('headquarterCity');
        if (cityControl) {
          if (cityControl.errors != null) {
            cityControl.setErrors(null);
            cityControl.updateValueAndValidity();
          }
        }
      }
    });
  }
  getMasterData() {
    let payload = {
      dataTypes: [
        'currency',
        'partyType'
      ],
    };
    const apiUrl = `${this.baseUrl}common-service/api/master-data`;
    this.http.post(apiUrl, payload).subscribe({
      next: (data: any) => {
        this.currencyData = data.response.data?.currency
        this.partyType1Data = data.response?.data?.partyType?.filter((x: any) => x.type == "PARTYTYPE1")
        this.partyType2Data = data.response?.data?.partyType?.filter((x: any) => x.type == "PARTYTYPE2")
        this.partyType3Data = data.response?.data?.partyType?.filter((x: any) => x.type == "PARTYTYPE3")
        this.partyType4Data = data.response?.data?.partyType?.filter((x: any) => x.type == "PARTYTYPE4")
      },
      error: (error) => {
        this.toastr.error(error.error.status.error.message);
      }
    });


  }

  customerProfileData(): void {
    const userid = sessionStorage.getItem('customeruserId') || '';
    let apiURL: any = `${this.baseUrl}customer/user-profile/getUserProfileCustomer?userId=${userid}`;
    this.commonService.getData(apiURL).subscribe((data: any) => {
      this.financeTab = data?.response?.financeTab;
      this.companyTab = data?.response?.companyTab;
      this.kycTabShow = data?.response?.kycTab;
      this.tncTab = data?.response?.tncTab;
    });
    this.setupSearchDebouncer();
    this.profileService.kycUpdated = false;
  }

  getRegionsListData() {
    this.profileService.requestDataForRegions().subscribe({
      next: (responseList: any) => {
        // region list
        this.regionsList = responseList[0].response;
        this.regionsList.forEach((region) => {
          this.regionWiseCountriesList.set(region.regionWisePresenceId, {
            countries: region.countries,
            regionWisePresenceName: region.regionWisePresenceName,
          });
        });
        // manpower list
        this.manPowerList = responseList[1].response;
        // revenue list
        this.revenueList = responseList[2].response;
        // categorieslist
        this.categoriesList = responseList[3].response;
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }

  getRegionName(region: any): string {
    if (this.regionWiseCountriesList) {
      return this.regionWiseCountriesList.get(region.value.regionWisePresenceId)
        ?.regionWisePresenceName;
    }
    return '';
  }

  getRegionWiseCountries(region: any) {
    if (this.regionWiseCountriesList) {
      return this.regionWiseCountriesList.get(region.value.regionWisePresenceId)
        ?.countries;
    }
    return [];
  }

  addRegionData(regions: any) {
    const addedRegions: any = [];
    regions.forEach((region: any, index: number) => {
      if (region?.regionWisePresenceId) {
        this.addRegion(region.regionWisePresenceId, region.id);
        addedRegions.push(region.regionWisePresenceId);
      }
      if (region?.countries) {
        region?.countries.forEach(
          (regionCountry: any, countryIndex: number) => {
            this.addRegionCountry(index, regionCountry);
          }
        );
      }
    });
    this.regionSelectionForm.controls['selectedRegion'].patchValue(
      addedRegions
    );
  }

  initializeYearOptions(): void {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 100; // Change the number of years as needed

    for (let year = currentYear; year >= startYear; year--) {
      this.yearOptions.push(year);
    }
  }

  addRegionCountry(regionIndex: number, countryValues?: any) {
    this.regionCountries(regionIndex).push(this.newCountry(countryValues));
  }

  removeRegionCountry(regionIndex: number, countryIndex: number) {
    const deletedCountry = this.regionCountries(regionIndex).at(countryIndex);
    if (
      deletedCountry.value.hasOwnProperty('id') &&
      deletedCountry.value.id !== null
    ) {
      this.deletedCountries.push(deletedCountry.value.id);
    }
    this.regionCountries(regionIndex).removeAt(countryIndex);
  }

  regions(): FormArray {
    return this.regionsForm.get('regions') as FormArray;
  }

  newRegion(regionValue?: string, regionId?: number): FormGroup {
    const createCountryForm = regionId ? [] : [this.newCountry()];
    return this.formBuilder.group({
      regionWisePresenceId: new FormControl(regionValue || ''),
      id: new FormControl(regionId || null),
      countries: this.formBuilder.array(createCountryForm),
    });
  }

  addRegion(value?: any, regionId?: number) {
    this.regions().push(this.newRegion(value, regionId));
  }

  addedRegion(selection: any) {
    this.regionSelect.close();
    if (selection?.source?.selected && selection.isUserInput) {
      this.addRegion(selection.source.value);
    }
    if (!selection?.source?.selected && selection.isUserInput) {
      const regionIndex = this.regionsForm.value.regions.findIndex(
        (region: any) => region.regionWisePresenceId === selection.source.value
      );
      this.removeRegion(regionIndex);
    }
  }

  removeRegion(regionIndex: number) {
    const deletedRegion = this.regions().at(regionIndex);
    if (
      deletedRegion?.value.hasOwnProperty('id') &&
      deletedRegion?.value.id !== null
    ) {
      this.deletedRegions.push(deletedRegion.value.id);
    }
    this.regions().removeAt(regionIndex);
    const newRegions = Array.from(
      new Set(
        this.regionsForm.value.regions.map(
          (region: any) => region.regionWisePresenceId
        )
      )
    );
    this.regionSelectionForm.controls['selectedRegion'].patchValue(newRegions);
  }

  regionCountries(regionIndex: number): FormArray {
    return this.regions().at(regionIndex).get('countries') as FormArray;
  }

  disabledCountries(regionIndex: number, countryId: number): boolean {
    const disabledCountries: number[] = [];
    this.regionCountries(regionIndex).value.forEach((countryValue: any) => {
      disabledCountries.push(countryValue.countryId);
    });

    return disabledCountries.includes(countryId) ? true : false;
  }

  disabledRemoveCountry(region: any, regionIndex: number): boolean {
    return this.regions().value[regionIndex].countries?.length === 1
      ? true
      : false;
  }

  disabledAddCountries(region: any, regionIndex: number): boolean {
    return this.regions().value[regionIndex].countries?.length >=
      this.getRegionWiseCountries(region)?.length
      ? true
      : false;
  }

  newCountry(countryValue?: any): FormGroup {
    const parseCategories = countryValue?.categories
      ? JSON.parse(countryValue?.categories)
      : '';
    return this.formBuilder.group({
      id: new FormControl(countryValue?.id || null),
      countryId: new FormControl(countryValue?.countryId || null, [
        Validators.required,
      ]),
      companySizeId: new FormControl(countryValue?.companySizeId || null, [
        Validators.required,
      ]),
      turnoverId: new FormControl(countryValue?.turnoverId || null, [
        Validators.required,
      ]),
      categories: new FormControl(parseCategories || null, [
        Validators.required,
      ]),
    });
  }

  onSubmit() { }

  createCompanyProfileForm() {
    this.companyProfileForm = new FormGroup({
      companyName: new FormControl('', Validators.required),
      companyContact: new FormControl(''),
      companyAddress: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      addressLine2: new FormControl('', [ Validators.maxLength(50)]),
      addressLine3: new FormControl('', [ Validators.maxLength(50)]),
      country: new FormControl('', Validators.required),
      countryName: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      pincode: new FormControl('', [
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(6)]),
      globalVat: new FormControl(''),
      pan: new FormControl(''),
      industry: new FormControl(''),
      industries: new FormControl('', Validators.required),
      websiteUrl: new FormControl(''),
      establishmentYear: new FormControl('', Validators.required),
      publicated: new FormControl(''),
      interest: new FormControl(''),
      timeline: new FormControl('', Validators.required),
      otherTimeline: new FormControl('', Validators.required),
      turnover: new FormControl('', Validators.required),
      companySize: new FormControl('', Validators.required),
      isDevelopmentNew: new FormControl(''),
      isItHeadquarter: new FormControl(true),
      partyType1: new FormControl(null),
      partyType2: new FormControl(null),
      partyType3: new FormControl(null),
      otherEntityType: new FormControl(""),
      customerCurrency: new FormControl(null),
      partyType4: new FormControl(""),
      msmeRegistered: new FormControl(""),
      mailToCC: new FormControl('', [this.commaSeparatedEmailsValidator])
    });

    this.headQuaterForm = this.formBuilder.group({
      headquarterCountryId: ['', Validators.required],
      headquarterState: ['', Validators.required],
      headquarterCity: ['', Validators.required],
      headquarterPincode: ['', [
        Validators.required,
        Validators.maxLength(6),
        Validators.minLength(6)]],
      headquarterAddress: ['', Validators.required],
    });
  }

  createFinanceProfileForm() {
    this.financeProfileForm = new FormGroup({
      bankName: new FormControl(''),
      accountNo: new FormControl(''),
      ifscCode: new FormControl(''),
      cancelledCheque: new FormControl(''),
      globalVat: new FormControl(''),
      pan: new FormControl(''),
      currency: new FormControl(''),
    });
  }

  commaSeparatedEmailsValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const emails = control.value.split(',').map((e: string) => e.trim());
    if (emails.length > 5) {
      return { maxEmails: true };
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (let email of emails) {
      if (!email || !emailRegex.test(email)) {
        return { invalidEmail: true };
      }
    }
    return null;
  }
  companyProfile() {  
    this.loading = true;
    const apiUrl = `${this.baseUrl}customer/profile?userId=${this.userId}`;
    this.commonService.getData(apiUrl).subscribe((data: any) => {
      this.profileInfo1 = data.response;
      let countryId = this.profileInfo1?.customerCompanyProfile?.countryId;
      const businessProfile = this.profileInfo1?.customerCompanyProfile?.customerCompanyMetadata
      this.companyProfileForm.patchValue({
        companyName: this.profileInfo1?.customerCompanyProfile?.name,
        companyContact:
          this.profileInfo1?.customerCompanyProfile?.contactNumber,
        companyAddress: this.profileInfo1?.customerCompanyProfile?.address,
        addressLine2: this.profileInfo1?.customerCompanyProfile?.addressLine2,
        addressLine3: this.profileInfo1?.customerCompanyProfile?.addressLine3,
        country: this.profileInfo1?.customerCompanyProfile?.countryId,
        countryName: this.profileInfo1?.customerCompanyProfile?.countryName,
        state: this.profileInfo1?.customerCompanyProfile?.stateName,
        city: this.profileInfo1?.customerCompanyProfile?.cityName,
        pincode: this.profileInfo1?.customerCompanyProfile?.pincode,
        pan: this.profileInfo1?.customerCompanyProfile?.panNumber,
        industry: this.profileInfo1?.customerCompanyProfile?.industryId,
        websiteUrl: this.profileInfo1?.customerCompanyProfile?.websiteUrl,
        establishmentYear: this.profileInfo1?.customerCompanyProfile
          ?.establishmentYear
          ? JSON.parse(
            this.profileInfo1?.customerCompanyProfile?.establishmentYear
          )
          : '',
        publicated: this.profileInfo1?.customerCompanyProfile?.isPublicated,
        timeline: this.profileInfo1?.customerCompanyProfile?.timelineName,
        otherTimeline: this.profileInfo1?.customerCompanyProfile?.timelineOther,
        turnover: this.profileInfo1?.customerCompanyProfile?.turnover,
        companySize: this.profileInfo1?.customerCompanyProfile?.companySize,
        isItHeadquarter:
          this.profileInfo1?.customerCompanyProfile?.isItHeadquarter ?? true,

        //business profile
        partyType1: {
          code: businessProfile?.partyType1Code,
          description: businessProfile?.partyType1
        },
        partyType2: {
          code: businessProfile?.partyType2Code,
          description: businessProfile?.partyType2
        },
        partyType3: {
          code: businessProfile?.partyType3Code,
          description: businessProfile?.partyType3,
        },
        partyType4: businessProfile?.partyType4,
        msmeRegistered: businessProfile?.msmeRegistered,
        customerCurrency: {
          currencyTypeCode: businessProfile?.currencyCode,
          currencyType: businessProfile?.currency,
        },
        mailToCC: this.profileInfo1?.customerCompanyProfile?.customerCompanyMetadata?.additionalEmails
      });
      
      this.getStatebyId(countryId);
      this.domesticOrInternationalCheck();
      this.uploadedCertificateInfo = [businessProfile?.msmeCert]
      this.isHeaquarterAdrressSame =
        this.profileInfo1?.customerCompanyProfile?.isItHeadquarter ?? true;

      if (!this.isHeaquarterAdrressSame) {
        this.headQuaterForm.patchValue({
          headquarterCity:
            this.profileInfo1?.customerCompanyProfile?.headquaterCityName,
          headquarterPincode:
            this.profileInfo1?.customerCompanyProfile?.headquaterPincode,
          headquarterAddress:
            this.profileInfo1?.customerCompanyProfile?.headquaterAddress,
          headquarterCountryId:
            +this.profileInfo1?.customerCompanyProfile?.headquaterCountryId,
          headquarterState:
            this.profileInfo1?.customerCompanyProfile?.headquaterStateName,
        });
        this.getHeadQuarterStateById(this.profileInfo1?.customerCompanyProfile?.headquaterCountryId);
      }

      this.headquarterCountryName = this.countryData.find(
        (data: any) =>
          this.profileInfo1?.customerCompanyProfile?.headquaterCountryId ==
          data.id
      );

      if (!this.isHeaquarterAdrressSame) {
        this.showHeadquarterForm = true;
      }
      this.uploadedDocumentInfo =
        this.profileInfo1?.customerCompanyProfile?.brochureDoc;
      this.getInterest(data.response?.customerCompanyProfile.interests);
      this.getIndustry(data.response?.customerCompanyProfile.industries);
      this.addRegionData(
        data.response?.customerCompanyProfile.regionWisePresences
      );
      if (this.profileInfo1?.customerCompanyProfile?.isDevelopmentNew == true) {
        this.companyProfileForm.patchValue({
          isDevelopmentNew: '1',
        });
      } else {
        this.companyProfileForm.patchValue({
          isDevelopmentNew: '2',
        });
      }
    });
   // this.domesticOrInternationalCheck();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  // Method to compare objects by code (or id)
  comparePartyType = (option: any, value: any): boolean => {
    return option && value ? option.code === value.code : option === value;
  };

  // Method to compare objects by code (or currencyCode)
  displayCurrency(currency: any): string {
    return currency ? currency.currencyType : '';
  }

  compareCurrency(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.currencyType === c2.currencyType : c1 === c2;
  }

  financeProfile() {
    const apiUrl = `${this.baseUrl}customer/profile?userId=${this.userId}`;
    this.commonService.getData(apiUrl).subscribe((data: any) => {
      this.profileInfo = data.response;
      this.financeProfileForm.patchValue({
        bankName: this.profileInfo?.finance?.bankName,
        accountNo: this.profileInfo?.finance?.accountNumber,
        ifscCode: this.profileInfo?.finance?.bankCode,
        cancelledCheque: this.profileInfo?.finance?.cancelledCheque,
        globalVat: this.profileInfo?.finance?.globalVat,
        pan: this.profileInfo?.finance?.pan,
        currency: this.profileInfo?.finance?.currency,
      });
    });
  }

  onToggleChange(event: any) {
    const slideToggle = event.source as MatSlideToggle; // Cast the event source to MatSlideToggle
    this.showHeadquarterForm = !slideToggle.checked;

    const companyProfileInfo = this.profileInfo1.customerCompanyProfile;

    this.isHeaquarterAdrressSame = !this.isHeaquarterAdrressSame;

    this.headQuaterForm.patchValue({
      headquarterAddress: companyProfileInfo?.isItHeadquarter
        ? ''
        : companyProfileInfo?.headquaterAddress,
      headquarterCountryId: companyProfileInfo?.isItHeadquarter
        ? ''
        : +companyProfileInfo?.headquaterCountryId,
      headquarterState: companyProfileInfo?.isItHeadquarter
        ? ''
        : companyProfileInfo?.headquaterStateName,
      headquarterCity: companyProfileInfo?.isItHeadquarter
        ? ''
        : companyProfileInfo?.headquaterCityName,
      headquarterPincode: companyProfileInfo?.isItHeadquarter
        ? ''
        : companyProfileInfo?.headquaterPincode,
    });
  }

  getHeadquarterState() {
    this.headQuaterForm
      ?.get('headquarterCountryId')
      ?.valueChanges.subscribe((x: any[]) => {
        this.commonService
          .getData(
            `${this.baseUrl}common-service/state-management?countryId=${first(
              x
            )}`
          )
          .subscribe((res) => {
            this.headquarterstateData = res?.response;
            this.getHeadquarterCity();
          });
      });
  }

  getHeadquarterCity() {
    this.headQuaterForm
      ?.get('headquarterState')
      ?.valueChanges.subscribe((x) => {
      });
  }

  updateUserData() {
    // delete uploaded brochure file if deleted by user
    if (
      !this.profileInfo1?.customerCompanyProfile?.brochureDoc?.hasOwnProperty(
        'fileName'
      ) &&
      this.uploadedDocumentInfo?.id
    ) {
      this.deleteBrochureFile(this.uploadedDocumentInfo?.id);
      this.uploadedDocumentInfo = {};
    }
    //company details
    let industry: any = this.industryData.find(
      (data: any) => this.companyProfileForm.value.industry == data.id
    );
    let country: any = this.countryData.find(
      (data: any) => this.companyProfileForm.value.country == data.id
    );

    this.regionsForm.value.regions.forEach((region: any, index: number) => {
      if (
        region.id == null &&
        region.countries.every((country: any) => country.countryId == null)
      ) {
        this.removeRegion(index);
      }
      region.countries.forEach((country: any) => {
        country.categories = JSON.stringify(country.categories);
      });
    });

    if (this.companyProfileForm.value.isDevelopmentNew == '1') {
      this.developmentPayload = true;
    } else {
      this.developmentPayload = false;
    }

    const state = this.stateData.find(x => x.stateName == this.companyProfileForm.value.state) || null
    const city = this.cityData.find(x => x.cityName == this.companyProfileForm.value.city) || null

    this.companyupdatedData = {
      userId: this.userId,
      name: this.companyProfileForm.value.companyName,
      address: this.companyProfileForm.value.companyAddress,
      addressLine2: this.companyProfileForm.value.addressLine2,
      addressLine3: this.companyProfileForm.value.addressLine3,
      websiteUrl: this.companyProfileForm.value.websiteUrl,
      countryId: this.companyProfileForm.value.country,
      countryName: country?.countryName,
      countryCode: country?.emproCountryCode || null,
      stateId: state?.id,
      stateCode: state?.emproStateCode || null,
      stateName: this.companyProfileForm.value.state,
      cityId: city?.id,
      cityCode: city?.emproCityCode || null,
      cityName: this.companyProfileForm.value.city,
      pincode: this.companyProfileForm.value.pincode,
      headquaterAddress: this.companyProfileForm.value.companyAddress,
      headquaterCountryId: this.companyProfileForm.value.country,
      headquaterCountryName: country?.countryName,
      headquaterStateId: null,
      headquaterStateName: this.companyProfileForm.value?.state,
      headquaterCityId: null,
      headquaterCityName: this.companyProfileForm.value.city,
      headquaterPincode: this.companyProfileForm.value.pincode,
      isItHeadquarter: this.companyProfileForm.value.isItHeadquarter,
      panNumber: this.companyProfileForm.value.pan,
      industryId: this.companyProfileForm.value.industry,
      industryName: industry?.industryName,
      contactNumber: this.companyProfileForm.value.companyContact.e164Number,
      
      regionWisePresences: this.regionsForm.value.regions,
      removedRegionIds: this.deletedRegions,
      removedCountryIds: this.deletedCountries,

      //business profiles
      customerCompanyMetadata: {
        partyType1: this.companyProfileForm.value.partyType1.description ?? this.companyProfileForm.value.partyType1.description,
        partyType1Code: this.companyProfileForm.value.partyType1.code ?? this.companyProfileForm.value.partyType1.code,
        partyType2: this.companyProfileForm.value.partyType2.description ?? this.companyProfileForm.value.partyType2.description,
        partyType2Code: this.companyProfileForm.value.partyType2.code ?? this.companyProfileForm.value.partyType2.code,
        partyType3: this.companyProfileForm.value.partyType3.description ?? this.companyProfileForm.value.partyType3.description,
        partyType3Code: this.companyProfileForm.value.partyType3.code ?? this.companyProfileForm.value.partyType3.code,
        partyType4: this.companyProfileForm.value.partyType4,
        msmeRegistered: this.companyProfileForm.value.msmeRegistered,
        msmeCert: this.uploadedCertificateInfo?.[0] ?? null,
        currency: this.companyProfileForm.value.customerCurrency.currencyType ?? this.companyProfileForm.value.customerCurrency.currencyType,
        currencyCode: this.companyProfileForm.value.customerCurrency.currencyTypeCode ?? this.companyProfileForm.value.customerCurrency.currencyTypeCode,
        additionalEmails: this.companyProfileForm.value.mailToCC,
      },

      establishmentYear: this.companyProfileForm.value.establishmentYear,
      publicated: this.companyProfileForm.value.publicated,
      industries: this.industryData.map((obj) => {
        obj.sectors = JSON.stringify(obj.sectors);
        return obj;
      }),
      interests: this.interestData.map((obj) => {
        obj.interestValues = JSON.stringify(obj.interestValues);
        return obj;

        //add new fields here

      }),
      timelineId: 1,
      timelineName: this.companyProfileForm?.value?.timeline?.length
        ? this.companyProfileForm?.value?.timeline
        : null,
      timelineOther:
        this.companyProfileForm.value.timeline === 'others'
          ? this.companyProfileForm.value.otherTimeline
          : null,
      isDevelopmentNew: this.developmentPayload,
      brochureDoc:
        this.uploadedDocumentInfo == null ? {} : this.uploadedDocumentInfo,
      turnoverId: this.turnOvers.find(
        (item: any) =>
          item.turnoverRange === this.companyProfileForm.value.turnover
      )?.turnoverId,
      turnover: this.companyProfileForm.value.turnover,
      companySizeId: this.companySizeData.find(
        (item: any) =>
          item.companySizeName === this.companyProfileForm.value.companySize
      )?.companySizeId,
      companySize: this.companyProfileForm.value.companySize,
    };

    country = this.countryData.find(
      (data: any) => this.headQuaterForm.value.headquarterCountryId == data.id
    );

    if (!this.companyProfileForm.value?.isItHeadquarter) {
      this.companyupdatedData.headquaterCityId = null;
      this.companyupdatedData.headquaterStateId = null;

      this.companyupdatedData.headquaterCountryName = country?.countryName;

      this.companyupdatedData.headquaterCityName =
        this.headQuaterForm.value.headquarterCity;

      this.companyupdatedData.headquaterPincode =
        this.headQuaterForm.value.headquarterPincode;

      this.companyupdatedData.headquaterAddress =
        this.headQuaterForm.value.headquarterAddress;

      this.companyupdatedData.headquaterCountryId =
        this.headQuaterForm.value.headquarterCountryId;

      this.companyupdatedData.headquaterStateName =
        this.headQuaterForm.value?.headquarterState;
    }

    this.UpdateCompanyDetails();
    this.saveNewZipCode();
    //finance details

    this.financeUpdatedData = {
      accountNumber: this.financeProfileForm.value.accountNo,
      bankCode: this.financeProfileForm.value.ifscCode,
      bankName: this.financeProfileForm.value.bankName,
      cancelledCheque: this.financeProfileForm.value.cancelledCheque,
      userId: this.userId,
      globalVat: this.financeProfileForm.value.globalVat,
      panNumber: this.financeProfileForm.value.panNumber,
      currency: this.financeProfileForm.value.currency,
      pan: this.financeProfileForm.value.pan,
    };
    //this.UpdateFinanceDetails();
  }

  UpdateCompanyDetails() {
    const apiURL = `${this.baseUrl}customer/lead-management/updateCustomerCompany/`;

    this.commonService
      .update(apiURL, this.userId, this.companyupdatedData)
      .subscribe((res: any) => {
        if (res.status.responseStatus === 'Success') {
          this.router.navigate(['/profile']);
        }
      });
  }

  UpdateFinanceDetails() {
    //Update API
    const apiUrl = `${this.baseUrl}customer/lead-management/updateFinance/`;

    this.commonService
      .update(apiUrl, this.userId, this.financeUpdatedData)
      .subscribe(() => {
        this.toastr.success('Profile updated successfully');
        this.financeProfile();
        this.router.navigate(['/profile']);
      });
  }

  searchSupplierZipHeadquarter(): void {
    this.searchZipcodeHeadquarter =
      this.headQuaterForm.value.headquarterPincode;
    this.zipDebouncerHeadquarter$.next(this.searchZipcodeHeadquarter);
  }

  onChangeCountryHeadQuarter() {
    this.getHeadquarterState();
    this.headQuaterForm?.get('headquarterCity')?.reset();
    this.headQuaterForm?.get('headquarterState')?.reset();
    this.headQuaterForm?.get('headquarterPincode')?.reset();
    this.headQuaterForm
      ?.get('headquarterCountryId')
      ?.valueChanges.subscribe((x: any[]) => {
        // this.showHStateCitySelect =
        //   first(x) == 101 || first(x) == 105 ? true : false;
      });

    this.headquarterCountryName = this.countryData.find(
      (data: any) => this.headQuaterForm.value.headquarterCountryId == data.id
    );
  }

  onTabClick(event: any) {
    this.kycTab = false;
    if (event.tab.textLabel == 'Finances') {
      this.updateFlag = 2;
    }
    if (event.tab.textLabel == 'KYC') {
      this.kycTab = true;
    }
  }

  resetUserProfileData() {
    this.companyProfileForm.reset();
    this.financeProfileForm.reset();
    this.regions().clear();
    this.companyProfile();
    this.financeProfile();
    this.resetFileUpload = true;
    this.toastr.success('Reset successfully done');
  }

  getSelectedIndustryList() {
    let selectedIndustries = this.companyProfileForm.value.industry;
    this.industryData.forEach((item: any) => {
      if (item && item.sectors) {
        item.sectors.forEach((val: any) => {
          if (selectedIndustries && selectedIndustries.length) {
            selectedIndustries.forEach((x: any) => {
              if (
                x[0] == val.sectorId &&
                this.selectedIndustryList.some(
                  (y: any) => y.industryId == item.id
                )
              ) {
                this.selectedIndustryList
                  .find((z: any) => z.industryId == item.id)
                  ?.sectors.push(x[0]);
              } else if (
                x[0] == val.sectorId &&
                !this.selectedIndustryList.some(
                  (y: any) => y.industryId == item.id
                )
              ) {
                let obj = {
                  industryId: item.id,
                  industryName: item.industryName,
                  sectors: [x[0]],
                };
                this.selectedIndustryList.push(obj);
              }
            });
          }
        });
      }
    });
  }

  getCountry() {
    console.log("getting country data");
    this.commonService
      .getData(`${this.baseUrl}common-service/country-management`)
      .subscribe((res) => {
        this.countryData = res?.response;
        this.headQuarterCountryData = res?.response;
        this.companyProfile();
      });
  }

  getCinCountry() {
    this.commonService
      .getData(
        `${this.baseUrl}common-service/country-management/all-cin-by-countryName`
      )
      .subscribe((res) => {
        this.cinCountryData = res?.response;
      });
  }
  countryChanged(ev: any) {
    if (ev.value == 'Others') {
      this.isCinReadonly = false;
      this.KYCForm.get('cinType')?.setValue(null);
      this.KYCForm.get('cinCountryName')?.setValue(null);
      this.KYCForm.get('cinCountryId')?.setValue(null);
    } else {
      const cinDetails = this.cinCountryData?.find(
        (x) => x.countryName == ev.value
      );
      this.KYCForm.get('cinCountryName')?.setValue(cinDetails.countryName);
      this.KYCForm.get('cinCountryId')?.setValue(cinDetails.cinCountryId);
      this.KYCForm.get('cinType')?.setValue(cinDetails.cinName);
    }
  }

  getTimelineData() {
    this.commonService
      .getData(`${this.baseUrl}common-service/timeline`)
      .subscribe((res) => {
        this.timelineList = res?.response;
      });
  }

  fileUploadEvent(event: any): void {
    if (event?.fileUploadStatus) {
      this.toastr.success('File updated successfully');
      this.uploadedDocumentInfo = event;
      if (this.profileInfo1?.customerCompanyProfile?.brochureDoc?.id) {
        this.uploadedDocumentInfo.id =
          this.profileInfo1?.customerCompanyProfile?.brochureDoc?.id;
      }
    }
  }

  openDialog(): void {
    this.dialog
      .open(CancelledChequeDialogComponent, {
        width: '500px',
      })
      .afterClosed()
      .subscribe({
        next: (isTrue: boolean) => { },
      });
  }
  openInterestDialog(): void {
    this.dialog
      .open(InterestUpdateDialogComponent, {
        // width: '500px',
        // position: { right: '30%' },
        data: {
          data: JSON.parse(JSON.stringify(this.interestsList)),
          editable: true,
        },
      })
      .afterClosed()
      .subscribe({
        next: (res: any) => {
          if (res.isTrue) {
            this.setInterest(res.data);
            this.InterestValidation();
          }
        },
      });
  }
  getInterest(data: any[]) {
    let apiUrl = `${this.baseUrl}common-service/interest-management`;
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.interestsList = res.response;
        this.interestsList = this.interestsList.map((interest: any) => {
          let tempId = interest.id;
          interest.interestId = tempId;
          interest.id = null;
          interest.interestValues = interest.interestValues.map(
            (values: any) => {
              values['isChecked'] = false;
              if (data && data.length > 0) {
                data.forEach((interestCheckedData) => {
                  if (
                    interest.interestId == interestCheckedData.interestId &&
                    JSON.parse(interestCheckedData.interestValues).indexOf(
                      values.id
                    ) > -1
                  ) {
                    interest.id = interestCheckedData.id;
                    values['isChecked'] = true;
                  }
                });
              } else {
                values['isChecked'] = false;
              }

              return values;
            }
          );
          return interest;
        });
        this.setInterest(this.interestsList);
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  setInterest(data: any) {
    this.interestsList = JSON.parse(JSON.stringify(data));
    this.interestData = [];

    this.interestsList.forEach((interest: any) => {
      let interestValues: any[] = [];
      interest.interestValues.forEach((values: any) => {
        if (values.isChecked) {
          interestValues.push(values.id);
        }
      });
      if (interestValues.length > 0) {
        this.interestData.push({
          interestId: interest.interestId,
          id: interest.id,
          name: interest.name,
          interestValues: interestValues,
        });
      }
    });
  }
  openIndustryDialog(): void {
    this.dialog
      .open(IndustryUpdateDialogComponent, {
        // width: '500px',
        // position: { right: '30%' },
        data: {
          data: JSON.parse(JSON.stringify(this.industryList)),
          editable: true,
        },
      })
      .afterClosed()
      .subscribe({
        next: (res: any) => {
          if (res.isTrue) {
            this.setIndustry(res.data);
          }
        },
      });
  }
  getIndustry(data: any[]) {
    let apiUrl = `${this.baseUrl}common-service/industry-management`;
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.industryList = res.response;
        this.industryList = this.industryList.map((industry: any) => {
          let tempId = industry.id;
          industry.industryId = tempId;
          industry.id = null;
          industry.sectors = industry.sectors.map((sector: any) => {
            sector['isChecked'] = false;
            if (data && data.length > 0) {
              data.forEach((interestCheckedData) => {
                if (
                  industry.industryId == interestCheckedData.industryId &&
                  JSON.parse(interestCheckedData.sectors).indexOf(
                    sector.sectorId
                  ) > -1
                ) {
                  industry.id = interestCheckedData.id;
                  sector['isChecked'] = true;
                }
              });
            } else {
              sector['isChecked'] = false;
            }

            return sector;
          });
          return industry;
        });
        this.setIndustry(this.industryList);
      },
      error: (e) => {
        this.toastr.error(e.error.status.error.message);
      },
    });
  }
  setIndustry(data: any) {
    this.industryList = JSON.parse(JSON.stringify(data));
    this.industryData = [];

    this.industryList.forEach((industry: any) => {
      let sectors: any[] = [];
      industry.sectors.forEach((sector: any) => {
        if (sector.isChecked) {
          sectors.push(sector.sectorId);
        }
      });
      if (sectors.length > 0) {
        this.industryData.push({
          industryId: industry.industryId,
          id: industry.id,
          industryName: industry.industryName,
          sectors: sectors,
        });
      }
      if (
        industry.hasOwnProperty('others') &&
        industry.industryName === 'Others'
      ) {
        this.industryData.push({
          industryId: industry.industryId,
          id: industry.id,
          industryName: industry.industryName,
          sectors: industry.sectors,
          others: industry.others,
        });
      }
    });
  }

  downloadBrochureFile(brochureFileId: number, fileName: string): void {
    let apiUrl: string = `${this.baseUrl}supplier/document-management/supplierDocumentDownload?docId=${brochureFileId}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        let link = document?.createElement('a');
        link.href = data.response;
        link.download = fileName;
        link.target = '_blank';
        link.click();
      },
      error: (error) => {
        this.toastr.error(`Error while fetching the file from server`);
      },
    });
  }

  deleteBrochureFileLocal(): void {
    this.profileInfo1.customerCompanyProfile.brochureDoc = {};
  }

  deleteMsmeFileLocal(): void {
    this.resetFileUploader = true;
    this.uploadedCertificateInfo = [];
    this.profileInfo1.customerCompanyProfile.customerCompanyMetadata.msmeCert = {};
  }

  deleteBrochureFile(brochureFileId: number): void {
    let apiUrl: string = `${this.baseUrl}customer/document-management/deleteCustomerDocument?docId=${brochureFileId}&supplierId=${this.userId}`;
    this.commonService.delete(apiUrl).subscribe({
      next: (data: any) => {
        this.profileInfo1.customerCompanyProfile.brochureDoc = {};
      },
      error: (error) => {
        this.toastr.error(`Error while deleting the file.`);
      },
    });
  }

  InterestValidation() {
    interface Interest {
      id: number;
      interestValues: [];
      interestId: number;
    }
    const intetestArray: Interest[] = this.interestsList;
    this.interestsList.forEach((listofinterest: Interest) => {
      this.uniqueInterestIds.add(listofinterest.interestId);
    });

    this.interestData.forEach((_list: any) => {
      this.uniqueInterestIds.delete(_list.interestId);
    });
    if (this.uniqueInterestIds.size > 0) {
      this.interestValidation = true;
    } else {
      this.interestValidation = false;
    }
  }

  isValidUpdate() {
    if (
      this.companyProfileForm.controls['companyName'].status === 'INVALID' ||
      this.companyProfileForm.controls['companyAddress'].status === 'INVALID' ||
      this.companyProfileForm.controls['addressLine2'].status === 'INVALID' ||
      this.companyProfileForm.controls['addressLine3'].status === 'INVALID' ||
      this.companyProfileForm.controls['country'].status === 'INVALID' ||
      this.companyProfileForm.controls['state'].status === 'INVALID' ||
      this.companyProfileForm.controls['city'].status === 'INVALID' ||
      this.companyProfileForm.controls['pincode'].status === 'INVALID' ||
      this.companyProfileForm.controls['websiteUrl'].status === 'INVALID' ||
      this.companyProfileForm.controls['timeline'].status === 'INVALID' ||
      this.industryData.length == 0 ||
      this.interestValidation ||
      this.companyProfileForm.controls['companyContact'].status === 'INVALID' ||
      this.companyProfileForm.value.companyContact == null ||
      this.companyProfileForm.controls['mailToCC'].status === 'INVALID' ||
      this.companyProfileForm.controls['establishmentYear'].status ===
      'INVALID' ||
      this.companyProfileForm.controls['turnover'].status === 'INVALID' ||
      this.companyProfileForm.controls['companySize'].status === 'INVALID' ||
      (this.companyProfileForm.controls['timeline'].value == 'others' &&
        this.companyProfileForm.controls['otherTimeline'].status ==
        'INVALID') ||
      !this.isHeadquarterFormValid()
      // ||this.zipFlag === false
    ) {
      this.stepDisabled = true;
      return true;
    } else {
      this.stepDisabled = false;
      return false;
    }
  }

  isHeadquarterFormValid() {
    return this.isHeaquarterAdrressSame || this.headQuaterForm.valid;
  }

  ZipCountryName: String = '';
  zipCountryCode: String = '';
  SearchData() {
    if (
      this.companyProfileForm.value.pincode?.length >= 3 &&
      this.companyProfileForm.value.country
    ) {
      this.commonService
        .getData(
          `${this.baseUrl}auth-service/geo-code?address=${this.companyProfileForm.value.pincode}`
        )
        .subscribe((res) => {
          let data = res;
          let fullAddress = data.results[0]?.address_components;
          if (fullAddress !== undefined) {
            fullAddress.forEach((x: any) => {
              if (x.types[0] == 'country') {
                this.countryData.forEach((i: any) => {
                  if (i.id == this.companyProfileForm.value.country) {
                    this.ZipCountryName = i.countryName;
                    this.zipCountryCode = i.countryCode;
                  }
                });
                if (
                  this.ZipCountryName !== x.long_name &&
                  this.zipCountryCode !== x.short_name
                ) {
                  this.companyProfileForm?.get('state')?.reset();
                  this.companyProfileForm?.get('city')?.reset();
                  this.findZipCodeData();
                }
              }
              if (x.types[0] == 'administrative_area_level_1') {
                this.companyProfileForm.get('state')?.patchValue(x.long_name);
              }
              if (x.types[0] == 'administrative_area_level_2') {
                this.companyProfileForm.get('city')?.patchValue(x.long_name);
              } else if (x.types[0] == 'locality') {
                this.companyProfileForm.get('city')?.patchValue(x.long_name);
              }
            });
          } else {
            this.findZipCodeData();
          }
        });
    } else if (this.companyProfileForm.value.pincode?.length == 0) {
      this.companyProfileForm?.get('city')?.reset();
      this.companyProfileForm?.get('state')?.reset();
    }
  }

  onChangeCountry() {
    this.companyProfileForm?.get('city')?.reset();
    this.companyProfileForm?.get('state')?.reset();
    this.companyProfileForm?.get('pincode')?.reset();
    this.companyProfileForm
      ?.get('country')
      ?.valueChanges.subscribe((x: any) => {
      });

    this.countryName = this.countryData.find(
      (data: any) => this.companyProfileForm.value.country == data.id
    );
  }

  zipcodeConfirmation() {
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;
      const dialogRef = this.dialog.open(ZipcodeConfirmationDialogComponent, {
        disableClose: true,
        panelClass: 'zipcodepopup',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == false) {
          this.companyProfileForm?.get('city')?.reset();
          this.companyProfileForm?.get('state')?.reset();
          this.companyProfileForm?.get('pincode')?.reset();
        } else if (result == true) {
          this.companyProfileForm?.get('city')?.reset();
          this.companyProfileForm?.get('state')?.reset();
        }
        this.isDialogOpen = false;
      });
    }
  }

  setupSearchDebouncer() {
    this.zipDebouncer$.pipe(debounceTime(1500)).subscribe((term: string) => {
      this.searchZipcode = term;
      this.SearchData();
    });
  }
  searchSupplierZip(): void {
    this.searchZipcode = this.companyProfileForm.value.pincode;
    this.zipDebouncer$.next(this.searchZipcode);
  }

  setupSearchDebouncerHeadquarter() {
    this.zipDebouncerHeadquarter$
      .pipe(debounceTime(1500))
      .subscribe((term: string) => {
        this.searchZipcodeHeadquarter = term;
        this.SearchDataHeadQuarter();
      });
  }

  SearchDataHeadQuarter() {
    if (
      this.headQuaterForm.value.headquarterPincode?.length >= 3 &&
      this.headQuaterForm.value.headquarterCountryId
    ) {
      this.commonService
        .getData(
          `${this.baseUrl}auth-service/geo-code?address=${this.headQuaterForm.value.headquarterPincode}`
        )
        .subscribe((res) => {
          let data = res;
          this.fullAddressHeadQuarter = data.results[0]?.address_components;
          if (this.fullAddressHeadQuarter !== undefined) {
            this.fullAddressHeadQuarter.forEach((x: any) => {
              if (x.types[0] == 'country') {
                this.countryData.forEach((i: any) => {
                  if (i.id == this.headQuaterForm.value.headquarterCountryId) {
                    this.zipCountryCode = i.countryCode;
                    this.ZipCountryName = i.countryName;
                  }
                });
                if (
                  this.headquarterCountryName?.countryName !== x.long_name &&
                  this.ZipCountryName !== x.long_name &&
                  this.zipCountryCode !== x.short_name
                ) {
                  this.headQuaterForm?.get('headquarterCity')?.reset();
                  this.headQuaterForm?.get('headquarterState')?.reset();
                  this.findZipCodeDataHeadquarter();
                }
              }
              if (x.types[0] == 'administrative_area_level_1') {
                this.headQuaterForm
                  .get('headquarterState')
                  ?.patchValue(x.long_name);
              }
              if (x.types[0] == 'administrative_area_level_2') {
                this.headQuaterForm
                  .get('headquarterCity')
                  ?.patchValue(x.long_name);
              } else if (x.types[0] == 'locality') {
                this.headQuaterForm
                  .get('headquarterCity')
                  ?.patchValue(x.long_name);
              }
            });
          } else {
            this.findZipCodeDataHeadquarter();
          }
        });
    } else if (this.headQuaterForm.value.headquarterPincode?.length == 0) {
      this.headQuaterForm?.get('headquarterCity')?.reset();
      this.headQuaterForm?.get('headquarterState')?.reset();
    }
  }

  findZipCodeDataHeadquarter() {
    this.commonService
      .getData(
        `${this.baseUrl}common-service/pincode-management?countryId=${this.headQuaterForm.value.headquarterCountryId}&countryName=${this.headquarterCountryName?.countryName}&pinCode=${this.headQuaterForm.value.headquarterPincode}`
      )
      .subscribe((res) => {
        this.sampleDataHeadQuarter = res?.response;
        if (this.sampleDataHeadQuarter?.stateName !== null) {
          this.headQuaterForm
            .get('headquarterState')
            ?.patchValue(this.sampleDataHeadQuarter?.stateName);
          this.headQuaterForm
            .get('headquarterCity')
            ?.patchValue(this.sampleDataHeadQuarter?.cityName);
        } else {
          this.zipcodeConfirmationHeadquarter();
        }
      });
  }

  zipcodeConfirmationHeadquarter() {
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;
      const dialogRef = this.dialog.open(ZipcodeConfirmationDialogComponent, {
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result == false) {
          this.headQuaterForm?.get('headquarterCity')?.reset();
          this.headQuaterForm?.get('headquarterState')?.reset();
          this.headQuaterForm?.get('headquarterPincode')?.reset();
        } else if (result == true) {
          this.headQuaterForm?.get('headquarterCity')?.reset();
          this.headQuaterForm?.get('headquarterState')?.reset();
        }
        this.isDialogOpen = false;
      });
    }
  }

  saveNewZipCode() {
    let payload = {
      countryId: this.companyProfileForm.value.country,
      countryName: this.countryName?.countryName,
      stateName: this.companyProfileForm.value.state,
      cityName: this.companyProfileForm.value.city,
      pinCode: this.companyProfileForm.value.pincode,
    };
    const apiURL = `${this.baseUrl}common-service/pincode-management`;
    this.commonService
      .postDatawithoutHeaders(apiURL, payload)
      .subscribe((res: any) => { });
  }

  findZipCodeData() {
    const countryNameUrl = this.countryName?.countryName
      ? `${this.baseUrl}common-service/pincode-management?countryId=${this.companyProfileForm.value.country}&countryName=${this.countryName?.countryName}&pinCode=${this.companyProfileForm.value.pincode}`
      : `${this.baseUrl}common-service/pincode-management?countryId=${this.companyProfileForm.value.country}&countryName=${this.companyProfileForm.value.countryName}&pinCode=${this.companyProfileForm.value.pincode}`;
    this.commonService.getData(countryNameUrl).subscribe((res) => {
      this.sampleData = res?.response;
      if (this.sampleData?.stateName !== null) {
        this.companyProfileForm
          .get('state')
          ?.patchValue(this.sampleData?.stateName);
        this.companyProfileForm
          .get('city')
          ?.patchValue(this.sampleData?.cityName);
      } else {
        this.zipcodeConfirmation();
      }
    });
  }

  getTurnOver() {
    this.commonService
      .getData(`${this.baseUrl}common-service/turnover`)
      .subscribe((res) => {
        this.turnOvers = res?.response;
      });
  }
  getCompanySize() {
    this.commonService
      .getData(`${this.baseUrl}common-service/company-size`)
      .subscribe((res) => {
        this.companySizeData = res?.response;
      });
  }

  createKYCForm() {
    this.KYCForm = new FormGroup({
      // softwareCAD: new FormControl(false, Validators.required),
      companyName: new FormControl('', Validators.required),
      legalName: new FormControl('', Validators.required),
      categoryOfBusiness: new FormControl('', Validators.required),
      businessOthers: new FormControl(''),
      regCompName: new FormControl('', Validators.required),
      regBuilding: new FormControl('', Validators.required),
      regCompStreet: new FormControl('', Validators.required),
      regCompPincode: new FormControl('', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]),
      regCompCountry: new FormControl('', Validators.required),
      regCompAuthPerson: new FormControl('', Validators.required),
      regCompDesignation: new FormControl('', Validators.required),
      regCompEmail: new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
      regCompMobile: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\+?\d{10,15}$/),
      ]),
      regCompTelephone: new FormControl('', [
        Validators.pattern(/^\+?\d{10,15}$/),
      ]),
      corCompName: new FormControl('', Validators.required),
      corBuilding: new FormControl('', Validators.required),
      corCompStreet: new FormControl('', Validators.required),
      corCompPincode: new FormControl('', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]),
      corCompCountry: new FormControl('', Validators.required),
      corCompEmail: new FormControl('', [
        Validators.required,
        Validators.email,
      ]),
      corCompMobile: new FormControl('', [
        Validators.required,
        Validators.pattern(/^\+?\d{10,15}$/),
      ]),
      corCompTelephone: new FormControl('', [
        Validators.pattern(/^\+?\d{10,15}$/),
      ]),
      legalStatus: new FormControl('', Validators.required),
      bankName: new FormControl('', Validators.required),
      accountNumber: new FormControl('', [
        Validators.required,
        Validators.pattern(/^-?\d*\.?\d+$/),
      ]),
      ibanNumber: new FormControl(''),
      swiftCode: new FormControl('', Validators.required),
      bankAddress: new FormControl('', Validators.required),
      nameAsPerRecord: new FormControl('', Validators.required),
      yearOne: new FormControl(this.lastThreeYears[0], Validators.required),
      yearTwo: new FormControl(this.lastThreeYears[1], Validators.required),
      yearThree: new FormControl(this.lastThreeYears[2], Validators.required),
      yearOneRevenue: new FormControl(0, [
        Validators.pattern(/^\d*\.?\d*$/),
      ]),
      yearTwoRevenue: new FormControl(0, [
        Validators.pattern(/^\d*\.?\d*$/),
      ]),
      yearThreeRevenue: new FormControl(0, [
        Validators.pattern(/^\d*\.?\d*$/),
      ]),
      cinType: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      cinNumber: new FormControl('', Validators.required),
      taxType: new FormControl('', Validators.required),
      taxNumber: new FormControl('', Validators.required),
      cinCountryId: new FormControl(''),
      cinCountryName: new FormControl(''),
      panNumber: new FormControl('', Validators.required),

    });
  }

  getkycData() {
    let customerId = sessionStorage.getItem('customercompanyId') || '';
    let apiUrl = `${this.baseUrl}customer/customer-kyc-details/get-kyc-details/${customerId}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (res: any) => {
        this.kycData = res?.response;
        this.patchKYCData();
        this.kycData.kycFiles.forEach((item: any) => {
          let obj = {
            id: item?.id,
            fileId: item?.fileId,
            fileName: item?.fileName,
            fileType: item?.fileType,
            fileExtension: item?.fileExtension,
            fileSize: item?.fileSize,
            uploadedBy: UserType.Customer,
            useFor: item?.useFor,
            location: item?.location,
            useForId: item?.useForId,
          };
          this.kycFilesMap.set(item.useFor, obj);
        });
        this.showBusinessOthers =
          this.kycData?.categoryOfBusiness?.toLowerCase() == 'others'
            ? true
            : false;
        this.showBusinessOthers
          ? this.KYCForm.controls['businessOthers'].setValidators(
            Validators.required
          )
          : this.KYCForm.controls['businessOthers'].clearValidators();
        this.KYCForm.controls['businessOthers'].updateValueAndValidity();
      },
      error: (e) => {
        if (e?.error?.status?.error?.message)
          this.toastr.error(e?.error?.status?.error?.message);
      },
    });
  }

  updateBusinessOthersValidation() {
    this.KYCForm.controls['categoryOfBusiness'].valueChanges.subscribe({
      next: (value: string) => {
        if (value?.toLowerCase() == 'others') {
          this.showBusinessOthers = true;
          this.KYCForm.controls['businessOthers'].setValidators(
            Validators.required
          );
        } else {
          this.showBusinessOthers = false;
          this.KYCForm.controls['businessOthers'].setValue(null);
          this.KYCForm.controls['businessOthers'].clearValidators();
        }
        this.KYCForm.controls['businessOthers'].updateValueAndValidity();
      },
    });
  }

  patchKYCData() {
    this.KYCForm.patchValue({
      companyName: this.kycData.companyName,
      legalName: this.kycData.legalName,
      registrationNumber: this.kycData.registrationNumber,
      categoryOfBusiness: this.kycData.categoryOfBusiness,
      businessOthers: this.kycData.businessOthers,
      regCompName: this.kycData.regCompName,
      regBuilding: this.kycData.regBuilding,
      regCompStreet: this.kycData.regCompStreet,
      regCompPincode: this.kycData.regCompPincode,
      regCompCountry: this.kycData.regCompCountryName,
      regCompAuthPerson: this.kycData.regCompAuthPerson,
      regCompDesignation: this.kycData.regCompDesignation,
      regCompEmail: this.kycData.regCompEmail,
      regCompMobile: this.kycData.regCompMobile,
      regCompTelephone: this.kycData.regCompTelephone,
      corCompName: this.kycData.corCompName,
      corBuilding: this.kycData.corBuilding,
      corCompStreet: this.kycData.corCompStreet,
      corCompPincode: this.kycData.corCompPincode,
      corCompCountry: this.kycData.corCompCountryName,
      corCompEmail: this.kycData.corCompEmail,
      corCompMobile: this.kycData.corCompMobile,
      corCompTelephone: this.kycData.corCompTelephone,
      legalStatus: this.kycData.legalStatusName,
      bankName: this.kycData.bankName,
      accountNumber: this.kycData.accountNumber,
      ibanNumber: this.kycData.ibanNumber,
      swiftCode: this.kycData.swiftCode,
      bankAddress: this.kycData.bankAddress,
      nameAsPerRecord: this.kycData.nameAsPerRecord,
      yearOne: Number(this.kycData.yearOne)
        ? Number(this.kycData.yearOne)
        : this.lastThreeYears[0],
      yearTwo: Number(this.kycData.yearTwo)
        ? Number(this.kycData.yearTwo)
        : this.lastThreeYears[1],
      yearThree: Number(this.kycData.yearThree)
        ? Number(this.kycData.yearThree)
        : this.lastThreeYears[2],
      yearOneRevenue: Number(this.kycData.yearOneRevenue) || null,
      yearTwoRevenue: Number(this.kycData.yearTwoRevenue) || null,
      yearThreeRevenue: Number(this.kycData.yearThreeRevenue) || null,
      cinType: this.kycData.cinType,
      cinNumber: this.kycData.cinNumber || null,
      taxType: this.kycData.taxType,
      taxNumber: this.kycData.taxNumber,
      cinCountryId: this.kycData.cinCountryId,
      cinCountryName: this.kycData.cinCountryName,
      country: this.kycData.cinCountryName,
      panNumber: this.kycData.panNumber,

    });
  }

  getCancelledCheque(event: any) {
    this.showCancelledCheque = false;
    this.cancelledCheque = event.target.files[0];
    this.cancelledChequeslocalArr = event.target.files;
  }

  downloadKycFile(id: number, fileName: string): void {
    downloadFiles(this.baseUrl, this.commonService, this.toastr, id, fileName);
  }

  async updateKYC() {
    this.SendKYCData();
  }

  awsBasicUploadSinglee(url: string, file: any) {
    const HttpUploadOptions = {
      headers: new HttpHeaders({ 'Content-Type': file.type }),
    };
    this.http.put(url, file, HttpUploadOptions).subscribe({
      next: (data: any) => {
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error);
      },
    });
  }

  SendKYCData() {
    let supplierId = sessionStorage.getItem('customercompanyId') || '';
    let KYCFormValue = this.KYCForm.value;
    const payload = {
      customerId: Number(supplierId),
      companyName: KYCFormValue.companyName,
      legalName: KYCFormValue.legalName,
      registrationNumber: null,
      categoryOfBusinessId: this.categoryOfBusiness.find(
        (item: any) => item.name == KYCFormValue.categoryOfBusiness
      )?.id,
      categoryOfBusiness: KYCFormValue.categoryOfBusiness,
      businessOthers: KYCFormValue.businessOthers,
      regCompName: KYCFormValue.regCompName,
      regBuilding: KYCFormValue.regBuilding,
      regCompStreet: KYCFormValue.regCompStreet,
      regCompPincode: KYCFormValue.regCompPincode,
      regCompCountryId: this.countryData.find(
        (item) => item.countryName == KYCFormValue.regCompCountry
      )?.id,
      regCompCountryName: KYCFormValue.regCompCountry,
      regCompAuthPerson: KYCFormValue.regCompAuthPerson,
      regCompDesignation: KYCFormValue.regCompDesignation,
      regCompEmail: KYCFormValue.regCompEmail,
      regCompMobile: KYCFormValue.regCompMobile,
      regCompTelephone: KYCFormValue.regCompTelephone,
      corCompName: KYCFormValue.corCompName,
      corBuilding: KYCFormValue.corBuilding,
      corCompStreet: KYCFormValue.corCompStreet,
      corCompPincode: KYCFormValue.corCompPincode,
      corCompCountryId: this.countryData.find(
        (item) => item.countryName == KYCFormValue.corCompCountry
      )?.id,
      corCompCountryName: KYCFormValue.corCompCountry,
      corCompEmail: KYCFormValue.corCompEmail,
      corCompMobile: KYCFormValue.corCompMobile,
      corCompTelephone: KYCFormValue.corCompTelephone,
      legalStatusId: this.legalStatus.find(
        (item: any) => item.name == KYCFormValue.legalStatus
      )?.id,
      legalStatusName: KYCFormValue.legalStatus,
      bankName: KYCFormValue.bankName,
      accountNumber: KYCFormValue.accountNumber,
      ibanNumber: KYCFormValue.ibanNumber,
      swiftCode: KYCFormValue.swiftCode,
      bankAddress: KYCFormValue.bankAddress,
      nameAsPerRecord: KYCFormValue.nameAsPerRecord,
      yearOne: `${KYCFormValue.yearOne}`,
      yearTwo: `${KYCFormValue.yearTwo}`,
      yearThree: `${KYCFormValue.yearThree}`,
      yearOneRevenue: KYCFormValue.yearOneRevenue,
      yearTwoRevenue: KYCFormValue.yearTwoRevenue,
      yearThreeRevenue: KYCFormValue.yearThreeRevenue,
      cinType: KYCFormValue.cinType,
      cinTypeId: this.cinData.find(
        (item: any) => item.name == KYCFormValue.cinType
      )?.id,
      cinNumber: KYCFormValue.cinNumber,
      taxNumber: KYCFormValue.taxNumber,
      taxType: KYCFormValue.taxType,
      taxTypeId: this.taxNumberData.find(
        (item: any) => item.name == KYCFormValue.taxType
      )?.id,
      kycFiles: Array.from(this.kycFilesMap.values()),
      cinCountryId: KYCFormValue.cinCountryId,
      cinCountryName: KYCFormValue.cinCountryName,
      panNumber: KYCFormValue.panNumber,

    };
    this.commonService
      .patchData(
        `${this.baseUrl}customer/customer-kyc-details/update-kyc-details`,
        payload
      )
      .subscribe({
        next: (res: any) => {
          this.router.navigate(['/profile']);
          this.toastr.success('KYC details updated successfully');
          this.profileService.kycUpdated = true;
        },
        error: (error: HttpErrorResponse) => { },
      });
  }

  getCategoryOfBusiness(): void {
    this.commonService
      .getData(`${this.baseUrl}common-service/category-of-business/category`)
      .subscribe({
        next: (res: any) => {
          this.categoryOfBusiness = res.response;
        },
      });
  }

  getLegalStatus() {
    this.commonService
      .getData(`${this.baseUrl}common-service/legal-status/get-all`)
      .subscribe({
        next: (res: any) => {
          this.legalStatus = res.response;
        },
      });
  }
  getCinManagement() {
    this.commonService
      .getData(`${this.baseUrl}common-service/cin-management`)
      .subscribe({
        next: (res) => {
          this.cinData = res.response;
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error);
        },
      });
  }

  getTaxNumberManagement() {
    this.commonService
      .getData(`${this.baseUrl}common-service/tax-number-management`)
      .subscribe({
        next: (res) => {
          this.taxNumberData = res.response;
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error);
        },
      });
  }

  getLastThreeYears() {
    let currentYear = new Date().getFullYear();
    this.lastThreeYears = [currentYear - 1, currentYear - 2, currentYear - 3];
  }

  downloadAttachedFile(): void {
    if (this.cancelledCheque) {
      let link = document?.createElement('a');
      link.href = window.URL.createObjectURL(this.cancelledCheque);
      link.download = this.cancelledCheque.name;
      link.target = '_blank';
      link.click();
    }
  }

  deleteAttachedFile() {
    this.showCancelledCheque = true;
    this.KYCForm.controls['cancelledCheque'].setValue('');
    this.cancelledCheque = '';
    this.kycData.kycAttachment = {};
    this.cancelledChequeFileSelector.nativeElement.value = '';
    this.KYCForm.controls['cancelledCheque'].setValidators(Validators.required);
    this.KYCForm.controls['cancelledCheque'].updateValueAndValidity();
  }

  correspondSameasreg(event: any) {
    let checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.setCorrespondanceAddress(true);
    } else {
      this.setCorrespondanceAddress(false);
    }
  }
  setCorrespondanceAddress(val: boolean) {
    let regCompName = this.KYCForm.get('regCompName')?.value;
    let regBuilding = this.KYCForm.get('regBuilding')?.value;
    let regCompStreet = this.KYCForm.get('regCompStreet')?.value;
    let regCompPincode = this.KYCForm.get('regCompPincode')?.value;
    let regCompCountry = this.KYCForm.get('regCompCountry')?.value;
    let regCompAuthPerson = this.KYCForm.get('regCompAuthPerson')?.value;
    let regCompDesignation = this.KYCForm.get('regCompDesignation')?.value;
    let regCompEmail = this.KYCForm.get('regCompEmail')?.value;
    let regCompMobile = this.KYCForm.get('regCompMobile')?.value;
    let regCompTelephone = this.KYCForm.get('regCompTelephone')?.value;

    if (val) {
      this.KYCForm.get('corCompName')?.setValue(regCompName);
      this.KYCForm.get('corBuilding')?.setValue(regBuilding);
      this.KYCForm.get('corCompStreet')?.setValue(regCompStreet);
      this.KYCForm.get('corCompPincode')?.setValue(regCompPincode);
      this.KYCForm.get('corCompCountry')?.setValue(regCompCountry);
      this.KYCForm.get('corCompEmail')?.setValue(regCompEmail);
      this.KYCForm.get('corCompMobile')?.setValue(regCompMobile);
      this.KYCForm.get('corCompTelephone')?.setValue(regCompTelephone);
      this.setCorrespondanceFiles();
      this.isSameAsAddress = true;
    } else {
      this.KYCForm.get('corCompName')?.setValue('');
      this.KYCForm.get('corBuilding')?.setValue('');
      this.KYCForm.get('corCompStreet')?.setValue('');
      this.KYCForm.get('corCompPincode')?.setValue('');
      this.KYCForm.get('corCompCountry')?.setValue('');
      this.KYCForm.get('corCompEmail')?.setValue('');
      this.KYCForm.get('corCompMobile')?.setValue('');
      this.KYCForm.get('corCompTelephone')?.setValue('');
      this.kycFilesMap.delete('CA_REGISTRATION_CERTIFICATES');
      this.kycFilesMap.delete('CA_OWNERSHIP_DOC');
      this.kycFilesMap.delete('CA_UTILITY_BILLS');
      this.isSameAsAddress = false;
    }
  }
  setCorrespondanceFiles() {
    let CA_REGISTRATION_CERTIFICATES = this.kycFilesMap.get(
      'RA_REGISTRATION_CERTIFICATES'
    );
    if (CA_REGISTRATION_CERTIFICATES) {
      const copyObj = cloneDeep(CA_REGISTRATION_CERTIFICATES);
      this.kycFilesMap.set('CA_REGISTRATION_CERTIFICATES', copyObj);
      let regsKey = this.kycFilesMap.get('CA_REGISTRATION_CERTIFICATES');
      regsKey.useFor = 'CA_REGISTRATION_CERTIFICATES';
    }
    let CA_OWNERSHIP_DOC = this.kycFilesMap.get('RA_OWNERSHIP_DOC');
    if (CA_OWNERSHIP_DOC) {
      const copyObjDoc = cloneDeep(CA_OWNERSHIP_DOC);
      this.kycFilesMap.set('CA_OWNERSHIP_DOC', copyObjDoc);
      let ownerKey = this.kycFilesMap.get('CA_OWNERSHIP_DOC');
      ownerKey.useFor = 'CA_OWNERSHIP_DOC';
    }
    let CA_UTILITY_BILLS = this.kycFilesMap.get('RA_UTILITY_BILLS');
    if (CA_UTILITY_BILLS) {
      const copyObjBil = cloneDeep(CA_UTILITY_BILLS);
      this.kycFilesMap.set('CA_UTILITY_BILLS', copyObjBil);
      let utilityKey = this.kycFilesMap.get('CA_UTILITY_BILLS');
      utilityKey.useFor = 'CA_UTILITY_BILLS';
    }
  }
  fileUploadEventKyc(fileUploadEvent: any, fileKey: any): void {
    const fileUploadData: any = fileUploadEvent;
    let dataItem: any = first(fileUploadData?.attachment);
    let payLoad = {
      fileId: dataItem?.id,
      fileName: dataItem?.fileName,
      fileType: dataItem?.fileType,
      fileExtension: dataItem?.type,
      fileSize: dataItem?.size,
      uploadedBy: UserType.Supplier,
      useFor: fileKey,
      location: dataItem?.location,
    };
    if (this.kycFilesMap.has(fileKey)) {
      if (!fileUploadData?.fileUploadStatus) {
        this.kycFilesMap.delete(fileKey);
      } else {
        let kycItem = this.kycFilesMap.get(fileKey);
        kycItem.fileId = dataItem?.id;
        kycItem.fileName = dataItem?.fileName;
        kycItem.fileType = dataItem?.fileType;
        kycItem.fileExtension = dataItem?.type;
        kycItem.fileSize = dataItem?.size;
        kycItem.uploadedBy = UserType.Supplier;
        kycItem.useFor = fileKey;
        kycItem.location = dataItem?.location;
      }
    } else {
      this.kycFilesMap.set(fileKey, payLoad);
    }
    if (!fileUploadData?.attachment?.length) {
      this.kycFilesMap.delete(fileKey);
    }
    if (fileUploadData?.fileUploadStatus) {
      this.toastr.success('File updated successfully');
    }
    if (this.isSameAsAddress) {
      this.setCorrespondanceFiles();
    }
  }
  getFileExist(fileKey: string): boolean {
    let mapValue: any = this.kycFilesMap.get(fileKey);
    return (this.kycFilesMap.get(fileKey) && mapValue.id) ?? false;
  }
  deleteKycFileLocal(fileKey: string, fileId: number) {
    this.kycFilesMap.delete(fileKey);
    let apiUrl: string = `${this.baseUrl}customer/files-management/delete/${fileId}`;
    this.commonService.delete(apiUrl).subscribe({
      next: (data: any) => {
        this.toastr.success('File Deleted successfully');
      },
      error: (error) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }
  isKYCValidFiles(map: Map<string, any>, keys: string[]): boolean {
    return keys.every((key) => map.has(key));
  }
  toggleAccordion(index: number) {
    this.activeIndex = index === this.activeIndex ? -1 : index;
  }
  blockInvalidChar(e: KeyboardEvent) {
    // Disallowed specific keys like scientific notation or negative sign
    const disallowedKeys = ['e', 'E', '-'];

    // Allow control/navigation keys
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Home',
      'End'
    ];

    // If disallowed key, block immediately
    if (disallowedKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }

    // Allow navigation and control keys
    if (allowedKeys.includes(e.key)) {
      return;
    }

    // Allow only alphanumeric keys
    const allowedRegex = /^[a-zA-Z0-9]$/;
    if (!allowedRegex.test(e.key)) {
      e.preventDefault();
    }
  }

  isPhoneValid(error: any): String {
    if (error != null && !error.validatePhoneNumber?.valid) {
      return 'Phone number is not valid';
    } else {
      return '';
    }
  }
  isPhoneRequired(error: any): String {
    if (error == null) {
      return 'Mobile number is required';
    } else {
      return '';
    }
  }
  msmeRegChange(ev: any) {
    ev.value === 'true'
      ? ((this.msmeCertificate = true), (this.uploadedCertificateInfo = []))
      : ((this.msmeCertificate = false), (this.uploadedCertificateInfo = null), (this.companyProfileForm.get('partyType4')?.setValue("")));
  }
  fileUpload(fileUploadEvent: any) {
    if (fileUploadEvent.fileUploadStatus && fileUploadEvent.attachment.length != 0) {
      this.uploadedCertificateInfo = fileUploadEvent.attachment
    }
    else {
      this.uploadedCertificateInfo = []
    }
  }
  onSearch(event: any) {
    const input = event.target as HTMLInputElement;
    this.searchInputState$.next(input.value);
  }
  onSearchCountry(event: any) {
    const input = event.target as HTMLInputElement;
    this.searchInputCountry$.next(input.value);
  }
  onSearchCity(event: any) {
    const input = event.target as HTMLInputElement;
    this.searchInputCity$.next(input.value);
  }
  onSearchHeadQuarter(event: any) {
    const input = event.target as HTMLInputElement;
    this.searchInputStateHeadQuarter$.next(input.value);
  }
  onSearchCountryHeadQuarter(event: any) {
    const input = event.target as HTMLInputElement;
    this.searchInputCountryHeadQuarter$.next(input.value);
  }
  onSearchCityHeadQuarter(event: any) {
    const input = event.target as HTMLInputElement;
    this.searchInputCityHeadQuarter$.next(input.value);
  }

  setupSearchStateDebouncer() {
    this.searchInputState$
      .pipe(
        debounceTime(500), // wait 0.5s after user stops typing
        distinctUntilChanged(), // ignore same consecutive values
        switchMap((term: string) => {
          const countryId = this.companyProfileForm.get('country')?.value;
          const url = `${this.baseUrl}common-service/state-management?countryId=${countryId}&tag=${term}`;
          return this.http.get<any[]>(url); // directly calling API
        })
      )
      .subscribe((data: any) => {
        this.stateData = data.response;
        if (this.stateData.length == 0) {
          const stateControl = this.companyProfileForm.get('state');

          if (stateControl) {
            stateControl.setErrors({ invalidState: true });
            this.companyProfileForm.get('city')?.setValue("");

          }
        }
      });
  }
  setupSearchCityDebouncer() {
    this.searchInputCity$
      .pipe(
        debounceTime(500), // wait 0.5s after user stops typing
        distinctUntilChanged(), // ignore same consecutive values
        switchMap((term: string) => {
          const selectedState = this.selectedStateId
          if (selectedState) {
            const url = `${this.baseUrl}common-service/city-management?stateId=${selectedState}&tag=${term}`;
            return this.http.get<any[]>(url); // directly calling API
          }
          else {
            return of({ response: [] });
          }
        })

      )
      .subscribe((data: any) => {
        this.cityData = data.response;
        if (this.cityData.length == 0) {
          const cityControl = this.companyProfileForm.get('city');

          if (cityControl) {
            cityControl.setErrors({ invalidCity: true });
          }
        }
      });
  }
  setupSearchCountryDebouncer() {
    this.searchInputCountry$
      .pipe(
        debounceTime(500), // wait 0.5s after user stops typing
        distinctUntilChanged(), // ignore same consecutive values
        switchMap((term: string) => {
          const url = `${this.baseUrl}common-service/country-management?tag=${term}`;
          return this.http.get<any[]>(url); // directly calling API
        })
      )
      .subscribe((data: any) => {
        this.countryData = data.response;
        if (this.countryData.length == 0) {
          const countryControl = this.companyProfileForm.get('country');
          if (countryControl) {
            countryControl.setErrors({ invalidCountry: true });
            this.companyProfileForm.get('state')?.setValue("");
            this.companyProfileForm.get('city')?.setValue("");
          }
        }
      });
  }
  getCountryName(countryId: any): string {
    typeof countryId === 'object' ? (countryId = countryId.id) : countryId;
    if (!countryId || !this.countryData) return '';
    const found = this.countryData.find((c: any) => c.id === countryId);
    return found ? found.countryName : '';
  }
  getHeadQuarterCountryName(countryId: any): string {
    typeof countryId === 'object' ? (countryId = countryId.id) : countryId;
    if (!countryId || !this.headQuarterCountryData) return '';
    const found = this.headQuarterCountryData.find((c: any) => c.id === countryId);
    return found ? found.countryName : '';
  }
  countrySelected(countryId: any) {
    const selectedCountry = this.countryData?.find((c: any) => c.id == countryId);
    this.companyProfileForm.get('country')?.setValue(countryId);
    this.companyProfileForm.get('countryName')?.setValue(selectedCountry ? selectedCountry.countryName : '');
    this.companyProfileForm.get('state')?.setValue('');
    this.companyProfileForm.get('city')?.setValue('');
    this.companyProfileForm.get('pincode')?.setValue('');
    this.domesticOrInternationalCheck();
    if (selectedCountry) {
      this.getStatebyId(countryId);
    }
  }

  onPincodeEnter(event: any) {
    if (this.companyProfileForm.get('countryName')?.value === 'India') {
      const pincodeControl = this.companyProfileForm.get('pincode');
      if (pincodeControl && event.target.value.length !== 6) {
        pincodeControl.setErrors({ invalidPincode: true });
      } else {
        pincodeControl?.setErrors(null);
      }
    }
  }

  domesticOrInternationalCheck() {
      const countryId = this.companyProfileForm.get('country')?.value;
      if (!countryId || !this.partyType2Data?.length) return;
      const targetCode = countryId == 106 ? 'DOM' : 'OVE';
      const matchingObject = this.partyType2Data.find(
        (item: any) => item.code === targetCode
      );
      if (matchingObject) {
        const ctrl = this.companyProfileForm.get('partyType2');
        ctrl?.patchValue({
          code: matchingObject.code,
         description: matchingObject.description,
        });
        ctrl?.updateValueAndValidity({ emitEvent: false });
      }
  }


  countrySelectedHeadquarter(countryId: any) {
    const selectedCountry = this.headQuarterCountryData?.find((c: any) => c.id == countryId);
    this.headQuaterForm.get('headquarterCountryId')?.setValue(countryId);
    this.headQuaterForm.get('countryName')?.setValue(selectedCountry ? selectedCountry.countryName : '');
    this.headQuaterForm.get('headquarterState')?.setValue('');
    this.headQuaterForm.get('headquarterCity')?.setValue('');
    this.headQuaterForm.get('headquarterPincode')?.setValue('');

    if (selectedCountry) {
      this.getHeadQuarterStateById(countryId);
    }
  }
  addCitySelected(city: any) {
    const state = this.companyProfileForm?.value?.state
  }
  addHeadQuarterCitySelected(city: any) {
    const state = this.headQuaterForm?.value?.headquarterState
  }
  addStateSelected(state: any) {
    this.companyProfileForm.get('state')?.setValue(state);
    this.companyProfileForm.get('city')?.setValue('');
    this.cityData = [];
  }
  addHeadQuarterStateSelected(state: any) {
    this.headQuaterForm.get('headquarterState')?.setValue(state);
    this.headQuaterForm.get('headquarterCity')?.setValue('');
    this.headquarterCityData = [];
  }
  stateSelected(option: any) {
    if (option.value.type && option.value.type == 'add') {
      this.addStateSelected(this.companyProfileForm.get('state')?.value?.name);
    } else {


      const state = this.stateData?.find((s) => s.stateName == option.value);
      if (!state || !state.id) {
        // If no state selected, reset related fields
        this.companyProfileForm.get('state')?.setValue('');
        this.companyProfileForm.get('city')?.setValue('');
        return;
      }

      this.companyProfileForm.get('state')?.setValue(state.stateName || '');
      this.companyProfileForm.get('city')?.setValue('');
      this.companyProfileForm.get('pincode')?.setValue('');

      this.selectedStateId = state.id;
      this.getCityById(state.id);
    }
  }
  headquarterStateSelected(option: any) {
    if (option.value.type && option.value.type == 'add') {
      this.addHeadQuarterStateSelected(this.headQuaterForm.get('headquarterState')?.value?.name);
    } else {
      const state = this.headquarterstateData?.find((s) => s.stateName == option.value);
      if (!state || !state.id) {
        // If no state selected, reset related fields
        this.headQuaterForm.get('headquarterState')?.setValue('');
        this.headQuaterForm.get('headquarterCity')?.setValue('');
        return;
      }

      this.headQuaterForm.get('headquarterState')?.setValue(state.stateName || '');
      this.headQuaterForm.get('headquarterCity')?.setValue('');
      this.headQuaterForm.get('headquarterPincode')?.setValue('');

      this.selectedStateId = state.id;
      this.getHeadQuarterCityById(state.id);
    }
  }
  getStatebyId(countryId: any) {
    this.commonService
      .getData(
        `${this.baseUrl}common-service/state-management?countryId=${countryId}&tag=`
      )
      .subscribe((res) => {
        this.stateData = res?.response;
        this.selectedStateId = this.stateData.find(
          (state) =>
            state?.stateName == this.companyProfileForm?.get('state')?.value
        )?.id;
        this.getCityById(this.selectedStateId);
      });

  }
  getHeadQuarterStateById(countryId: any) {
    this.commonService
      .getData(
        `${this.baseUrl}common-service/state-management?countryId=${countryId}&tag=`
      )
      .subscribe((res) => {
        this.headquarterstateData = res?.response;
        this.selectedStateId = this.headquarterstateData.find(
          (state) =>
            state?.stateName == this.companyProfileForm?.get('state')?.value
        )?.id;
        this.getHeadQuarterCityById(this.selectedStateId);
      });

  }
  getCityById(stateId: any) {
    if (stateId !== undefined) {
      this.commonService
        .getData(
          `${this.baseUrl}common-service/city-management?stateId=${stateId}&tag=`
        )
        .subscribe((res) => {
          this.cityData = res?.response;
        });
    }
  }
  getHeadQuarterCityById(stateId: any) {
    if (stateId !== undefined) {
      this.commonService
        .getData(
          `${this.baseUrl}common-service/city-management?stateId=${stateId}&tag=`
        )
        .subscribe((res) => {
          this.headquarterCityData = res?.response;
        });
    }
  }

  setupSearchStateHeadQuarterDebouncer() {
    this.searchInputStateHeadQuarter$
      .pipe(
        debounceTime(500), // wait 0.5s after user stops typing
        distinctUntilChanged(), // ignore same consecutive values
        switchMap((term: string) => {
          const countryId = this.headQuaterForm.get('headquarterCountryId')?.value;
          const url = `${this.baseUrl}common-service/state-management?countryId=${countryId}&tag=${term}`;
          return this.http.get<any[]>(url); // directly calling API
        })
      )
      .subscribe((data: any) => {
        this.headquarterstateData = data.response;
        if (this.headquarterstateData.length == 0) {
          const stateControl = this.headQuaterForm.get('headquarterState');
          if (stateControl) {
            stateControl.setErrors({ invalidState: true });
            this.headQuaterForm.get('headquarterCity')?.setValue("");
          }
        }
      });
  }
  setupSearchCityHeadQuarterDebouncer() {
    this.searchInputCityHeadQuarter$
      .pipe(
        debounceTime(500), // wait 0.5s after user stops typing
        distinctUntilChanged(), // ignore same consecutive values
        switchMap((term: string) => {
          // const countryId = this.companyProfileForm.get('country')?.value;
          const selectedState = this.headQuaterForm.get('headquarterState')?.value;
          const selectedStateId = this.headquarterstateData.find((x) => x.stateName == selectedState).id
          if (selectedStateId != undefined) {
            const url = `${this.baseUrl}common-service/city-management?stateId=${selectedStateId}&tag=${term}`;
            return this.http.get<any[]>(url); // directly calling API
          }
          else {
            // return an empty observable so chain doesn't break
            return of({ response: [] });
          }
        })

      )
      .subscribe((data: any) => {
        this.headquarterCityData = data.response;
        if (this.headquarterCityData.length == 0) {
          const cityControl = this.headQuaterForm.get('headquarterCity');
          if (cityControl) {
            cityControl.setErrors({ invalidCity: true });
          }
        }
      });
  }
  setupSearchCountryHeadQuarterDebouncer() {
    this.searchInputCountryHeadQuarter$
      .pipe(
        debounceTime(500), // wait 0.5s after user stops typing
        distinctUntilChanged(), // ignore same consecutive values
        switchMap((term: string) => {
          const url = `${this.baseUrl}common-service/country-management?tag=${term}`;
          return this.http.get<any[]>(url); // directly calling API
        })
      )
      .subscribe((data: any) => {
        this.headQuarterCountryData = data.response;
        if (this.headQuarterCountryData.length == 0) {
          const countryControl = this.headQuaterForm.get('headquarterCountryId');
          if (countryControl) {
            countryControl.setErrors({ invalidCountry: true });
            this.headQuaterForm.get('headquarterState')?.setValue("");
            this.headQuaterForm.get('headquarterCity')?.setValue("");
            this.headQuaterForm.get('headquarterPincode')?.setValue("");
          }
        }
      });
  }
  entityTypeChanged(event: any) {
    if (event.value.code == 'OTH') {
      this.showOtherEntityType = true
    }
    else {
      this.showOtherEntityType = false
      this.companyProfileForm.get('otherEntityType')?.setValue('')
    }
  }

  onTaxTypeChange() {
    const taxTypeCtrl = this.KYCForm.get('taxType');
    const taxNumberCtrl = this.KYCForm.get('taxNumber');

    if (taxTypeCtrl?.value === 'GST') {
      taxNumberCtrl?.setValidators([
        Validators.required,
        this.gstLengthValidator
      ]);
    } else {
      taxNumberCtrl?.setValidators([Validators.required]);
    }

    taxNumberCtrl?.updateValueAndValidity();
  }

  gstLengthValidator(control: any) {
    const value = control.value;
    if (!value) return null;
    return value.length === 15 ? null : { invalidGST: true };
  }

}
